import { render, staticRenderFns } from "./reversePhotoOfIdCard.vue?vue&type=template&id=b6841fd6&"
import script from "./reversePhotoOfIdCard.vue?vue&type=script&lang=js&"
export * from "./reversePhotoOfIdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports